









































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class RecordList extends Vue {
  @Prop(Function) private showEditModal: any;
  @Prop(Function) private hideHashKey: any;
  @Prop(Function) private showDeleteModal: any;
  @Prop(Function) private showGroupDeleteModal: any;
  @Prop(Function) private handleRowSelection: any;
  @Prop(Array) private list!: any[];
  @Prop(Number) private selectedItems!: number;
  @Prop(Array) private header!: any[];
  @Prop(Object) private keys!: { hashKey: string; rangeKey: string };
  @Prop({ type: Number, default: 0 }) private indexOffset!: number;

  private indexMethod(index: number) {
    return index + this.indexOffset + 1;
  }

  private compareByProp(a: any, b: any, prop: string) {
    const normalize = (value: any) => {
      if (value === undefined || value === null || value === '') {
        return { empty: true, rank: 3, value: '' };
      }
      if (typeof value === 'boolean' || value === 'true' || value === 'false') {
        return { empty: false, rank: 0, value: value === true || value === 'true' };
      }
      const numValue = Number(value);
      if (typeof value !== 'object' && !Number.isNaN(numValue)) {
        return { empty: false, rank: 1, value: numValue };
      }
      return { empty: false, rank: 2, value: String(value) };
    };
    const left = normalize(a[prop]);
    const right = normalize(b[prop]);
    if (left.empty || right.empty) {
      return left.empty === right.empty ? 0 : (left.empty ? 1 : -1);
    }
    if (left.rank === right.rank) {
      if (left.rank === 2) {
        return (left.value as string)
          .localeCompare(right.value as string, undefined, { sensitivity: 'base', numeric: true });
      }
      return left.value > right.value ? 1 : (left.value < right.value ? -1 : 0);
    }
    return left.rank - right.rank;
  }
}
